module.exports = __webpack_public_path__ + "static/media/step-pagamento-disable.5f8300cc.svg";